export default __webpack_public_path__ + "static/media/menu.74a61288.svg";